import React, { useState, useEffect, useRef } from "react";
import "./usuarios.css";
/* import CardFilter from "../CardFilter";
import UsuariosTable from "./UsuariosTable"; */
import * as api from "helper/helper";
import toast from "react-hot-toast";

/* import { FaPlus } from "react-icons/fa6";
import CreateUser from "./CreateUser"; */
import UsuariosCatalogo from "./UsuariosCatalogo";
import UsuariosDashboard from "./UsuariosDashboard";
import { Sections, SubSections } from "../../data/navItem";

export default function Usuarios({ subSectionId }) {
  /* const buttonModalRef = useRef(); */
  const buttonModalEditRef = useRef();
  const modalRef = useRef();
  /* const createClienteRef = useRef(); */
  //const [items, setItems] = useState([]);
  const [modalData, setModalData] = useState(null);
  /* const [editAddress, setEditAddress] = useState(null); */

  const [filter, setFilter] = useState("Hoy");
  const handleFilterChange = (filter) => {
    setFilter(filter);
  };

  //--
  const [usuarios, setUsuarios] = useState({});
  //const { username } = useAuthStore((state) => {

  const fetchData = async () => {
    const response = await api.usuarios().catch((e) => {
      toast.error("Error al pedir usuarios.");
    });
    if (!response) return;

    setUsuarios(response.data);

    console.log(response.status);
  };

  useEffect(() => {
    fetchData();
  }, []);

  function createUser(event) {
    console.log(event);
    setModalData(null);
  }

  function reloadUsuarios() {
    fetchData();
  }

  function loadItem(item) {
    console.log(modalRef);

    /*modalRef.current.style.display += "block";
    modalRef.current.classList.add("show");
    setOpenModal(true);*/
    setModalData(item);

    buttonModalEditRef.current.click();
  }

  return (
    <>
      {subSectionId === SubSections.Dashboard && <UsuariosDashboard />}
      {subSectionId === SubSections.Catalogo && <UsuariosCatalogo />}
      <UsuariosCatalogo />
    </>
  );
}
